import { InputAdornment, TextField as MuiTextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const SearchInput = (props: {
  searchTerm: string;
  onChange: (searchTerm: string) => void;
  placeholder: string;
  variant: 'sidebar' | 'standard';
}) => {

  const isStandardVariant = props.variant === 'standard';

  return (
    <MuiTextField
      className={isStandardVariant ? undefined : 'sidebar-search-input'}
      label=""
      placeholder={props.placeholder}
      variant="outlined"
      color="info"
      fullWidth
      value={props.searchTerm}
      onChange={(e) => props.onChange(e.target.value)}
      size="small"
      InputProps={{
        ...(isStandardVariant
          ? {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }
          : {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }),
      }}
    />
  );

};
